import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      nav("/");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Sign-in failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex bg-white" data-testid="login-page">
      <div className="hidden lg:block w-1/2 relative bg-[#050303]">
        <img
          src="https://images.pexels.com/photos/33133737/pexels-photo-33133737.jpeg?auto=compress&cs=tinysrgb&w=1600&h=1600&fit=crop"
          alt="Aerial view of the Atlanta skyline"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#050303]/85 via-[#050303]/40 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050303]/40 via-transparent to-[#050303]/60" />
        <div className="absolute top-10 left-12">
          <Logo variant="white" height={64} />
          <div className="mt-3 text-[10px] font-semibold tracking-[0.24em] uppercase text-[#e1b7c1]" data-testid="brand-motto">
            Real Estate Integrity at its CORE
          </div>
        </div>
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <div className="overline text-white/70 mb-3">CORE Realty and Associates LLC</div>
          <h1 className="font-heading text-5xl leading-tight max-w-md">CORE Realty and Associates — Tools &amp; Command Center for Agents.</h1>
          <p className="mt-4 text-white/80 text-sm">Metro Atlanta, and Georgia</p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="lg:hidden mb-6"><Logo variant="black" height={48} /></div>
          <div className="overline mb-3">Agent Login</div>
          <h2 className="font-heading text-4xl mb-2">Welcome back.</h2>
          <p className="text-sm text-[#050303]/60 mb-8">Sign in to your CORE Realty and Associates command center.</p>

          <label className="block text-xs font-semibold uppercase tracking-wider text-[#050303]/60 mb-2">Email</label>
          <input
            data-testid="login-email"
            value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full mb-5 px-4 py-3 border border-[#d1cece] rounded-lg focus:outline-none focus:border-[#bf858e] bg-white"
            type="email" required
          />

          <label className="block text-xs font-semibold uppercase tracking-wider text-[#050303]/60 mb-2">Password</label>
          <input
            data-testid="login-password"
            value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full mb-7 px-4 py-3 border border-[#d1cece] rounded-lg focus:outline-none focus:border-[#bf858e] bg-white"
            type="password" required
          />

          <button
            type="submit" disabled={busy}
            data-testid="login-submit"
            className="w-full bg-[#050303] text-white pill-btn hover:bg-[#bf858e] disabled:opacity-50"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
